const $sizes = ['xs', 'sm', 'md', 'lg', 'xl'];
const $positions = ['left', 'right', 'center'];

export function classNames(type, modifiers = {}) {
    let className = type;

    $sizes.map((size) => {
        if (modifiers.hasOwnProperty(size)) {
            className += '-' + size;
        }
    });

    $positions.map((position) => {
        if (modifiers.hasOwnProperty(position)) {
            className += '-' + position;
        }
    });

    return className;
} 


// WEBPACK FOOTER //
// ./src/baseComponents/directives/TextAlign/classNames.js